//src/app/features/auth/signUp/step-two/index.tsx
import { yupResolver } from '@hookform/resolvers/yup';
import { serviceTypeOptions } from 'app/features/profile/accountInfo/editAccountInfo/formFields';
import { MegaphoneIcon, ServiceTypeIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import { SelectInput } from 'Components/Auth/SelectInput/index';
import { Stepper } from 'Components/Auth/Stepper/index';
import { TextAreaInput } from 'Components/Documents/TextAreaInput';
import { useContext, useEffect } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { StepWizardChildProps } from 'react-step-wizard';
import { FormDataContext, SignUpContext } from '..';
import { FormFieldsTwo, initialData, validationSchema } from './formFields';

export const hearAboutUsOptions = [
  { label: 'Search Engine', value: 'Search Engine' },
  { label: 'From a friend', value: 'From a friend' },
  { label: 'From Facebook', value: 'From Facebook' },
  { label: 'Other', value: 'Other' },
];

const SignUpTwo: React.FC<Partial<StepWizardChildProps>> = ({
  previousStep,
}) => {
  const { formData, setFormData } = useContext(FormDataContext);

  const { isLoading, isError, resetRequestState, setLastStepClicked } =
    useContext(SignUpContext);
  const methods = useForm<FormFieldsTwo>({
    resolver: yupResolver(validationSchema),
    defaultValues: formData || initialData,
  });
  const { handleSubmit } = methods;

  const onSubmit: SubmitHandler<FormFieldsTwo> = async (data) => {
    const { hearAboutUs, other } = data;
    if (formData && setFormData) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        hearAboutUs: hearAboutUs === 'Other' ? other : hearAboutUs,
      }));
      setLastStepClicked!(true);
    }
  };

  useEffect(() => {
    if (isError) {
      previousStep!();
      resetRequestState!();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  return (
    <>
      <Stepper steps={['green', 'green']} />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <SelectInput
              name="hearAboutUs"
              label="How did you hear about us?"
              labelIcon={<MegaphoneIcon />}
              options={hearAboutUsOptions}
              type="select"
              placeholder="Select"
            />
          </div>
          {methods.getValues('hearAboutUs') === 'Other' && (
            <div className="mb-3 -mt-3">
              <TextAreaInput
                name="other"
                type="textarea"
                placeholder="Enter..."
              />
            </div>
          )}

          <CustomButton loading={isLoading} type="submit" text="Confirm" />
        </form>
      </FormProvider>
    </>
  );
};

export default SignUpTwo;
